import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Box,
  Typography,
  Paper,
} from "@mui/material";

type InfoModalProps = {
  open: boolean;
  onClose: () => void;
  data: Record<string, any> | null;
};

const InfoModal: React.FC<InfoModalProps> = ({ open, onClose, data }) => {
  if (!data) return null;

  const { type, ...userDetails } = data;
  const hasDetails = Object.keys(userDetails).length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        style: { borderRadius: 10 },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          backgroundColor: "#194e5b",
          color: "white",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          fontSize: 18,
          fontWeight: 600,
          py: 1.5,
        }}
      >
        Details
      </DialogTitle>

      <DialogContent sx={{ p: 2 }}>
        {/* Type Section */}
        <Box
          sx={{
            backgroundColor: "#eef6f6",
            borderRadius: 2,
            p: 1.5,
            mb: 2,
            mt: 2,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ color: "#194e5b", fontWeight: 600 }}
          >
            Type
          </Typography>
          <Typography variant="body2" sx={{ color: "#0E3843" }}>
            {type || "—"}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* User Details Section */}
        <Typography
          variant="subtitle2"
          sx={{ mb: 1, color: "#194e5b", fontWeight: 600 }}
        >
          User Details
        </Typography>

        {hasDetails ? (
          <Box display="flex" flexDirection="column" gap={0.8}>
            {Object.entries(userDetails).map(([key, value]) => (
              <Paper
                key={key}
                elevation={0}
                sx={{
                  backgroundColor: "#f8f9f9",
                  borderRadius: 1,
                  p: "6px 10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: "#194e5b",
                    textTransform: "capitalize",
                  }}
                >
                  {key.replace(/([A-Z])/g, " $1")}
                </Typography>
                <Typography variant="body2" sx={{ color: "#0E3843" }}>
                  {String(value) || "—"}
                </Typography>
              </Paper>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No user details available
          </Typography>
        )}
      </DialogContent>

      {/* Footer */}
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "#c9eeeb",
            color: "#0E3843",
            textTransform: "none",
            borderRadius: 1,
            "&:hover": {
              backgroundColor: "#b6e3e0",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
